import { useConfig } from 'config/use-config';
import { IBlogCategoryFields } from 'global';
import type { ArticleCard } from 'modules/magazine/contentful';
import { useRouter } from 'next/router';
import React from 'react';
import PaginationComponent from '../../../components/pagination';
import Slider from '../../content-cms/sections/slider';
import Breadcrumb from '../common/breadcrumb';
import { Pagination } from '../interface';
import BlogTile from '../magazine-home/blog-tile';

interface ISubCategory extends Pagination {
  mainCategoryFields: IBlogCategoryFields;
  subCategories: IBlogCategoryFields;
  blogEntries: ArticleCard[];
}

const SubCategory: React.FC<ISubCategory> = ({
  mainCategoryFields,
  subCategories,
  blogEntries,
  pages,
}) => {
  const { magazineBasePath } = useConfig();
  const router = useRouter();

  const handlePagination = (targetPage): void => {
    router.push(
      {
        pathname: `/${magazineBasePath}/${mainCategoryFields.handle}/${subCategories.handle}`,
        search: `page=${targetPage}`,
      },
      undefined,
      { shallow: true }
    );
  };

  return (
    <>
      <div
        data-test="categories-main-container"
        className="bg-background-default flex w-full flex-col items-center justify-start"
      >
        <div
          data-test="categories-sub-container"
          className="flex w-full max-w-360 flex-col items-center justify-center overflow-hidden px-6"
        >
          <div className="mt-10 mb-4 w-full" data-test="breadcrumbs-container">
            <Breadcrumb mainCategory={mainCategoryFields} subCategory={subCategories} />
          </div>
          <div
            data-test="categories-hero"
            className="flex w-full items-center justify-center overflow-hidden rounded-lg"
          >
            <Slider {...subCategories?.header.fields} />
          </div>
          <div
            data-test="articles-wrapper"
            className="flex w-full flex-wrap items-center justify-center md:grid-cols-2 md:px-20 lg:grid-cols-3 lg:justify-between"
          >
            {blogEntries.map((blogPost) => {
              return (
                <div key={blogPost.handle} className="mx-3 my-6 inline-block">
                  <BlogTile key={'blogTile-' + blogPost.handle} article={blogPost} />
                </div>
              );
            })}
          </div>
        </div>
        <PaginationComponent
          currentPage={pages.currentPage}
          totalPages={pages.totalPages}
          handlePagination={handlePagination}
        />
      </div>
    </>
  );
};

export default SubCategory;
